// extracted by mini-css-extract-plugin
module.exports = {"footerActions":"styles_footerActions__L3Th2","footerDisclaimer":"styles_footerDisclaimer__dQRkM","footer":"styles_footer__EZOCp"};